import {ItemConfiguracao} from './../../../model/catalogo';
import {Component, OnInit} from '@angular/core';
import {GlobalService} from './../../../service/global.service';
import {PesquisasFiltroApiService} from '../../../service/api/pesquisas-filtro.api';
import {Router} from '@angular/router';

@Component({
    selector: 'app-produto-transmissao',
    templateUrl: './produto-transmissao.component.html',
    styleUrls: ['./produto-transmissao.component.css']
})
export class ProdutoTransmissaoComponent implements OnInit {

    constructor(
        public pesquisaService: PesquisasFiltroApiService,
        public globalService: GlobalService,
        private router: Router,
    ) {
    }

    resultados: Array<ItemConfiguracao>;

    ngOnInit() {
        this.pesquisar();
    }

    pesquisar() {
        this.globalService.loading = true;
        let filtros: Array<any> = new Array<any>();
        filtros.push({'filtroItemConfiguracao': {'tipoItemConfiguracao': 1}});
        this.pesquisaService.filtraItemConfiguracao(filtros)
            .subscribe(
                listaItens => {
                    this.resultados = listaItens;
                    this.globalService.loading = false;
                },
                erro => {
                    this.globalService.loading = false;
                    if (erro.status == 404) {
                        this.resultados = new Array<ItemConfiguracao>();
                    }
                }
            );
    }

    detalha(nome, tipo) {
        this.router.navigate(['/detalha-produto-transmissao', nome, tipo]);
    }

    novo() {
        this.router.navigate(['/detalha-produto-transmissao', 'novo', 'cadastro']);
    }

}



// WEBPACK FOOTER //
// ./src/app/artefato/produto-transmissao/produto-transmissao.component.ts